import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NewOrder from './pages/NewOrder';
import Clients from './pages/Clients';
import Inventory from './pages/Inventory';
import Production from './components/Production';
import Reports from './components/Reports';
import Garantias from './pages/Garantias';
import MisEntregas from './pages/MisEntregas';
import Entregas from './pages/Entregas';
import Taller from './pages/Taller';
import Bodega from './pages/Bodega';
import MiTrabajo from './pages/MiTrabajo';
import PagosTaller from './pages/PagosTaller';

const PrivateRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex', alignItems:'center', justifyContent:'center', minHeight:'100vh' }}>Cargando...</div>;
  if (!user) return <Navigate to="/" />;
  if (roles && !roles.includes(user.role)) return <Navigate to={user.role === 'chofer' ? "/mis-entregas" : user.role === 'operario' ? "/mi-trabajo" : "/dashboard"} />;
  return children;
};

const AppRoutes = () => {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/" element={user ? <Navigate to={user.role === 'chofer' ? "/mis-entregas" : user.role === 'operario' ? "/mi-trabajo" : "/dashboard"} /> : <Login />} />
      <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/nueva-orden" element={<PrivateRoute roles={['admin','vendedor']}><NewOrder /></PrivateRoute>} />
      <Route path="/clientes" element={<PrivateRoute roles={['admin','vendedor']}><Clients /></PrivateRoute>} />
      <Route path="/inventario" element={<PrivateRoute roles={['admin','vendedor','inventario']}><Inventory /></PrivateRoute>} />
      <Route path="/produccion" element={<PrivateRoute roles={['admin']}><Production /></PrivateRoute>} />
      <Route path="/reportes" element={<PrivateRoute roles={['admin']}><Reports /></PrivateRoute>} />
      <Route path="/garantias" element={<PrivateRoute><Garantias /></PrivateRoute>} />
      <Route path="/mis-entregas" element={<PrivateRoute><MisEntregas /></PrivateRoute>} />
      <Route path="/entregas" element={<PrivateRoute roles={['admin']}><Entregas /></PrivateRoute>} />
      <Route path="/taller" element={<PrivateRoute roles={['admin','vendedor']}><Taller /></PrivateRoute>} />
      <Route path="/mi-trabajo" element={<PrivateRoute><MiTrabajo /></PrivateRoute>} />
      <Route path="/pagos-taller" element={<PrivateRoute roles={['admin']}><PagosTaller /></PrivateRoute>} />
      <Route path="/bodega" element={<PrivateRoute roles={['admin']}><Bodega /></PrivateRoute>} />
    </Routes>
  );
};

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
